import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Url } from "../router/enums";
import { RootState } from "../store";

//JIRA LPPLWEBMOB-749 + JIRA LPPLWEBMOB-750
export const useShouldRedirectToHomepage = (
  selector: (state: RootState) => boolean
): void | false => {
  const history = useHistory();
  const shouldRedirect = !useSelector(selector);
  const WelocomePageVisitedCookie = localStorage.getItem(
    "FormStartFromWelcome"
  );
  if (WelocomePageVisitedCookie == "true") {
    if (!shouldRedirect) {
      return false;
    } else {
      history.replace(Url.WELCOME);
    }
  } else {
    return false;
  }
};
